import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { map } from 'rxjs/operators';
import { JsonHttpService } from 'src/app/shared/http/json-http.service';
import { ReportConfiguration } from '../models/report-configuration';
import { ReportRunParameter } from '../models/reports-reportsrunparameters';
import { ReportsResult } from '../models/reports-reportsresult';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  private httpService = inject(JsonHttpService);

  // ***** Reports ***

  getReportConfigurations(id?: number): Promise<ReportConfiguration[]> {
    const options = { params: new HttpParams() };
    if (id) {
      options.params = options.params.append('id', id.toString());
    }
    return firstValueFrom(this.httpService.getTyped<ReportConfiguration[]>('/api/reports/get-reports', options).pipe(
      map(items => items.map(item => new ReportConfiguration(item))) // Convert to actual object instances
    ));
  }

  saveReportConfiguration(reportConfiguration: ReportConfiguration): Promise<ReportConfiguration> {
    return firstValueFrom(this.httpService.post('/api/reports/save-report', reportConfiguration));
  }

  deleteReportConfiguration(id: number): Promise<number> {
    const options = { params: new HttpParams().set('id', id.toString()) };
    return firstValueFrom(this.httpService.delete('/api/reports/delete-report', options));
  }

  runReport(id: number, parameters: ReportRunParameter[]): Promise<ReportsResult> {
    const options = { params: new HttpParams() };
    options.params = options.params.append('id', id.toString());
    return firstValueFrom(this.httpService.post('/api/reports/run-report', parameters, options));
  }

  async isReportNameUsed(name: string, myId?: number): Promise<boolean> {
    const configs: ReportConfiguration[] = await this.getReportConfigurations();
    const normalizedName = name.toLowerCase();

    return configs.some(config => (myId === undefined || config?.Report?.Id !== myId) && config?.Report?.Name?.toLowerCase() === normalizedName);
  }
}
